/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  function swymCallbackFn(swat) {
    var counter_elem = document.querySelectorAll(".swym-wish-counter"); /* Custom header can be added here.*/
    if (counter_elem) {
      for (var i = 0; i < counter_elem.length; i++) {
        if (swat.renderWishlistCount) {
          swat.renderWishlistCount(counter_elem[i]);
        }
      }
    }
    window.addEventListener("custom:initialize-swym", e => {
      swat.initializeActionButtons(e.detail.selector);
    });
  }
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(swymCallbackFn);
  window.addEventListener("unload", function () {
    document.querySelectorAll("form").forEach(form => form.reset());
  }, false);
  window.reinitReviews = () => {
    if (window.Yotpo) {
      document.querySelectorAll(".yotpo.bottomLine").forEach(ybl => {
        const content = ybl.innerHTML;
        if (content) {
          const replacement = document.createElement("div");
          replacement.classList.add("yotpo");
          replacement.innerHTML = content;
          ybl.parentElement.replaceChild(replacement, ybl);
        }
      });
      try {
        new Yotpo.API(yotpo).refreshWidgets();
      } catch (err) {
        console.log(err);
      }
    }
  };

  // (function getBreadcrumb() {
  //   const pathname = window.location.pathname;
  //   const includesCollection = pathname.includes("/collection/");
  //   const includesProduct = pathname.includes("/products/");
  //   if (
  //     (includesCollection && includesProduct) ||
  //     (!includesCollection && !includesProduct)
  //   ) {
  //     sessionStorage.removeItem("referrer-collection");
  //   } else if (includesCollection && !includesProduct) {
  //     sessionStorage.setItem(
  //       "referrer-collection",
  //       JSON.stringify({
  //         handle: window.location.pathname.split("/collections/")[1],
  //         title: document
  //           .querySelector('meta[property="og:title"]')
  //           ?.getAttribute("content"),
  //       })
  //     );
  //   } else if (!includesCollection && includesProduct) {
  //   }
  // })();

  (function replaceGlobaleBanner() {
    let timeElapsed = 0;
    const interval = setInterval(() => {
      timeElapsed += 500;
      const globaleBanner = document.querySelector(".ge-free-shipping-container");
      if (globaleBanner) {
        const replacements = document.querySelectorAll(".js-globale-replacement");
        if (replacements.length) {
          let text = globaleBanner.innerText.trim();
          if ([",00", ".00"].includes(text.slice(text.length - 3))) {
            text = text.slice(0, text.length - 3);
          }
          replacements.forEach(replacement => {
            replacement.innerText = text;
            replacement.classList.remove("js-globale-replacement");
          });
        } else if (!document.querySelector("[data-hide-globale]")) {
          globaleBanner.classList.add("--show");
        }
      }
      if (globaleBanner || timeElapsed >= 10000 || window.Shopify?.country === "US") {
        const replacements = document.querySelectorAll(".js-globale-replacement");
        replacements.forEach(replacement => {
          replacement.classList.remove("js-globale-replacement");
        });
        clearInterval(interval);
      }
    }, 500);
  })();
  (function convertCurrencies() {
    document.querySelectorAll(".js-convert-currency").forEach(tag => {
      const amount = Number(tag.dataset.amount);
      tag.innerText = window.formatMoney(Math.round(amount * window.Shopify.currency.rate));
    });
  })();
  (function manageStickyHeaderSections() {
    let headerSections = Array.from(document.querySelectorAll('[data-section-location="header"]')).map(section => ({
      el: section,
      height: section.offsetHeight
    }));
    let stickyHeaderSections = headerSections.map((section, idx) => {
      if (section.el.hasAttribute("data-sticky-header-section")) {
        return {
          ...section,
          minTopOffset: headerSections.slice(0, idx).filter(s => s.el.hasAttribute("data-sticky-header-section")).reduce((acc, s) => acc + s.height, 0),
          defaultTopOffset: headerSections.slice(0, idx).reduce((acc, s) => acc + s.height, 0)
        };
      }
    }).filter(Boolean);
    stickyHeaderSections.forEach(section => {
      section.el.parentElement.style.minHeight = `${section.height}px`;
    });
    const adjustPlacements = () => {
      stickyHeaderSections.forEach(section => {
        const el = section.el;
        if (el.getBoundingClientRect().top <= section.minTopOffset && el.style.position !== "fixed") {
          el.style.position = "fixed";
          el.style.top = `${section.minTopOffset}px`;
          // el.style.zIndex = 200;
        } else if (window.scrollY < section.defaultTopOffset - section.minTopOffset && el.style.position === "fixed") {
          el.style.position = "relative";
          el.style.top = "0px";
        }
      });
    };
    adjustPlacements();
    window.addEventListener("scroll", adjustPlacements);
  })();
  (function adjustMobileNavTopPosition() {
    const nav = document.querySelector(".drawer.drawer--nav");
    if (nav && document.querySelector("[data-announcement]")) {
      nav.classList.add("--lower");
    }
  })();

  // CUSTOM ELEMENTS BELOW:

  class CSWishlistBtn extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const uid = `cswb-${Date.now()}-${Math.floor(Math.random() * 1000)}`;
      this.classList.add(uid);
      window.dispatchEvent(new CustomEvent("custom:initialize-swym", {
        detail: {
          selector: "." + uid
        }
      }));
    }
  }
  customElements.define("cs-wishlist-button", CSWishlistBtn);
  class ATCForm extends HTMLElement {
    constructor(bundle) {
      super();
      if (!bundle) {
        this.variantSelector = this.querySelector("select[name=id]");
        this.variantSelector = {
          self: this.variantSelector,
          options: this.variantSelector ? Array.from(this.variantSelector.querySelectorAll("option")) : null
        };

        // Product options in squares
        this.variantSquareOptions = this.querySelectorAll("input[type=radio][name=id]");
      }
      this.atcButton = this.querySelector("button[type=submit]");
      this.bisButton = this.querySelector("button[data-bis-button]");
      this.bisPopup = this.querySelector("[data-bis-popup]");
      this.wrapper = this.closest(".form__wrapper");
      this.wishlistButton = this.closest(".product-single__wrapper")?.querySelector("cs-wishlist-button");
      this.remainingStockWrapper = this.wrapper?.querySelector("[data-remaining-wrapper]");
      this.priceWrappers = Array.from(this.wrapper?.querySelectorAll("[data-price-wrapper]") || []).map(priceWrapper => ({
        self: priceWrapper,
        priceEl: priceWrapper.querySelector("[data-product-price]"),
        comparePriceEl: priceWrapper.querySelector("[data-compare-price]"),
        priceOffEl: priceWrapper.querySelector("[data-price-off]")
      }));
      this.mediaGallery = (this.closest(".wrapper") || this.closest(".popup-quick-view__wrapper"))?.querySelector("[data-product-single-media-group]");
      if (this.mediaGallery) {
        this.mediaSlider = this.mediaGallery.querySelector("[data-product-single-media-slider]");
        this.mediaThumbs = this.mediaGallery.querySelector("[data-product-single-media-thumbs]");
        this.mediaSlider = {
          el: this.mediaSlider,
          slides: Array.from(this.mediaSlider.querySelectorAll("[data-product-single-media-wrapper]")),
          hidden: []
        };
        this.mediaThumbs = this.mediaThumbs ? {
          el: this.mediaThumbs,
          thumbs: Array.from(this.mediaThumbs.querySelectorAll(".product-single__thumbnail")),
          hidden: []
        } : null;
      }
      if (!bundle) {
        this.init();
      }
      this.updateMediaGallery = this.updateMediaGallery.bind(this);
    }
    init() {
      if (this.variantSelector.self) {
        const preSelectedOption = this.variantSelector.options.find(option => option.value === this.variantSelector.self.value);
        if (preSelectedOption && preSelectedOption.text.toLowerCase() !== "select size") {
          const selectValueEl = this.variantSelector.self.closest(".select-wrapper").querySelector("#SelectValue");
          selectValueEl.innerHTML = preSelectedOption.text;
          selectValueEl.classList.add("selected");
        }
        if (
        // preSelectedOption?.dataset.originalVariantHandle &&
        this.mediaGallery) {
          if (window.innerWidth <= 767) {
            let timeElapsed = 0;
            const interval = setInterval(() => {
              if (this.mediaGallery.querySelectorAll(".flickity-enabled").length === 2) {
                this.updateMediaGallery(preSelectedOption.dataset.variantTitle, preSelectedOption.dataset.originalVariantHandle, preSelectedOption.dataset.variantHandle);
                clearInterval(interval);
              }
              if (timeElapsed > 5000) clearInterval(interval);
              timeElapsed += 200;
            }, 200);
          } else {
            setTimeout(() => {
              this.updateMediaGallery(preSelectedOption.dataset.variantTitle, preSelectedOption.dataset.originalVariantHandle, preSelectedOption.dataset.variantHandle);
            }, 200);
          }
        }
        this.variantSelector.self.addEventListener("change", () => {
          const selectedName = this.variantSelector.self.options[this.variantSelector.self.selectedIndex].text;
          const selectedValue = this.variantSelector.self.value;
          const selectedOption = this.variantSelector.options.find(option => option.value === selectedValue);
          if (!selectedOption) return;
          const selectValueEl = this.variantSelector.self.closest(".select-wrapper").querySelector("#SelectValue");
          selectValueEl.innerHTML = selectedName;
          if (!selectValueEl.classList.contains("selected")) {
            selectValueEl.classList.add("selected");
          }
          const atcLabel = selectedOption.dataset.atcLabel;
          const variantTitle = selectedOption.dataset.variantTitle;
          const variantHandle = selectedOption.dataset.originalVariantHandle;
          const variantHandle2 = selectedOption.dataset.variantHandle;
          this.updateMediaGallery(variantTitle, variantHandle, variantHandle2);
          this.wrapper?.querySelector("product-swatches")?.handleVariantChange(selectedOption.dataset.variantHandle, selectedOption.value);
          this.updateAtcButton("single", selectedOption.dataset.soldOut === "true", selectedOption.dataset.soldOutButtonLabel, atcLabel);
          this.updateBisPopupSelection(selectedValue);
          this.updateBisButton(selectedOption.dataset.soldOut === "true" && !selectedOption.dataset.bisHidden, selectedOption.dataset.bisButtonLabel);
          this.updatePriceWrappers("single", selectedOption.dataset.price, selectedOption.dataset.comparePrice, selectedOption.dataset.priceOff);
          this.updateWishlistButton(selectedOption.dataset.wishlistButton);
          if (this.remainingStockWrapper) {
            const stock = Number(selectedOption.dataset.stock);
            this.updateRemainingStockWrapper(stock);
          }
          const searchParams = new URLSearchParams(window.location.search);
          searchParams.set("variant", selectedOption.value);
          window.history.replaceState(null, "", window.location.pathname + "?" + searchParams.toString());
        });
      } else if (this.variantSquareOptions.length) {
        let preSelectedOption;
        this.variantSquareOptions.forEach(option => {
          if (option.checked) {
            preSelectedOption = option;
          }
        });
        if (
        // preSelectedOption?.dataset.originalVariantHandle &&
        this.mediaGallery) {
          if (window.innerWidth <= 767) {
            let timeElapsed = 0;
            const interval = setInterval(() => {
              if (this.mediaGallery.querySelectorAll(".flickity-enabled").length === 2) {
                this.updateMediaGallery(preSelectedOption.dataset.variantTitle, preSelectedOption.dataset.originalVariantHandle, preSelectedOption.dataset.variantHandle);
                clearInterval(interval);
              }
              if (timeElapsed > 5000) clearInterval(interval);
              timeElapsed += 200;
            }, 200);
          } else {
            setTimeout(() => {
              this.updateMediaGallery(preSelectedOption.dataset.variantTitle, preSelectedOption.dataset.originalVariantHandle, preSelectedOption.dataset.variantHandle);
            }, 200);
          }
        }

        // listen to change event on radio buttons
        this.variantSquareOptions.forEach(option => {
          if (option.checked) {
            option.closest('.product-option-square').classList.add('selected');
          }
          if (option.disabled) {
            option.closest('.product-option-square').classList.add('disabled');
          }
          option.addEventListener("change", () => {
            const selectedOption = option;
            if (!selectedOption) return;
            this.variantSquareOptions.forEach(option => {
              option.closest('.product-option-square').classList.remove('selected');
            });
            selectedOption.closest('.product-option-square').classList.add('selected');
            const atcLabel = selectedOption.dataset.atcLabel;
            const variantTitle = selectedOption.dataset.variantTitle;
            const variantHandle = selectedOption.dataset.originalVariantHandle;
            const variantHandle2 = selectedOption.dataset.variantHandle;
            this.updateMediaGallery(variantTitle, variantHandle, variantHandle2);
            this.wrapper?.querySelector("product-swatches")?.handleVariantChange(selectedOption.dataset.variantHandle, selectedOption.value);
            this.updateAtcButton("single", selectedOption.dataset.soldOut === "true", selectedOption.dataset.soldOutButtonLabel, atcLabel);
            this.updateBisPopupSelection(selectedOption.value);
            this.updateBisButton(selectedOption.dataset.soldOut === "true" && !selectedOption.dataset.bisHidden, selectedOption.dataset.bisButtonLabel);
            this.updatePriceWrappers("single", selectedOption.dataset.price, selectedOption.dataset.comparePrice, selectedOption.dataset.priceOff);
            this.updateWishlistButton(selectedOption.dataset.wishlistButton);
            if (this.remainingStockWrapper) {
              const stock = Number(selectedOption.dataset.stock);
              this.updateRemainingStockWrapper(stock);
            }
            const searchParams = new URLSearchParams(window.location.search);
            searchParams.set("variant", selectedOption.value);
            window.history.replaceState(null, "", window.location.pathname + "?" + searchParams.toString());
          });
        });
      }
      this.bisButton?.addEventListener("click", () => {
        this.bisPopup.activate();
      });
    }
    updatePriceWrappers(type) {
      let price = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      let comparePrice = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
      let priceOff = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
      this.priceWrappers.forEach(priceWrapper => {
        priceWrapper.priceEl.innerText = price;
        priceWrapper.comparePriceEl.innerText = comparePrice;
        if (priceWrapper.priceOffEl) {
          priceWrapper.priceOffEl.querySelector("[data-price-off-amount]").innerText = priceOff;
        }
        priceWrapper.comparePriceEl.classList.toggle("hidden", !comparePrice);
        priceWrapper.priceOffEl?.classList.toggle("hidden", !priceOff ||
        // !window.theme.settings.showSavingBadge
        (type === "single" && !window.theme.settings.showSavingBadgeProductSingle || type === "bundle" && !window.theme.settings.showSavingBadgeProductBundle) && !window.theme.settings.showSaleBadge);
      });
    }
    updateRemainingStockWrapper(stock) {
      const className = "count-is-" + (stock <= 5 ? "out" : stock <= 10 ? "low" : "in");
      this.remainingStockWrapper.classList = `variant__countdown ${className}`;
    }
    updateAtcButton(type, soldOut, soldOutLabel, atcLabel) {
      const textContainer = this.atcButton.querySelector("[data-add-to-cart-text]");
      if (soldOut) {
        textContainer.innerText = soldOutLabel;
        this.atcButton.setAttribute("disabled", "disabled");
        if (type === "single") {
          this.atcButton.classList.add("hidden");
          this.querySelector(".GiftWizard-gift-button")?.classList?.add?.("hidden");
        } else {
          this.atcButton.classList.remove("hidden");
        }
      } else {
        textContainer.innerText = atcLabel || "Add to cart";
        this.atcButton.removeAttribute("disabled");
        this.atcButton.classList.remove("hidden");
        this.querySelector(".GiftWizard-gift-button")?.classList?.remove?.("hidden");
      }
    }
    updateBisButton(soldOut, label) {
      if (!this.bisButton) return;
      if (soldOut) {
        this.bisButton.innerText = label;
        this.bisButton.removeAttribute("disabled");
      } else {
        this.bisButton.setAttribute("disabled", "disabled");
      }
    }
    updateBisPopupSelection(selectedValue) {
      if (!this.bisPopup) return;
      this.bisPopup.querySelector('[name="variant_id"]').value = selectedValue;
    }
    updateWishlistButton(wishlistButton) {
      if (this.wishlistButton && wishlistButton) {
        const wrapper = document.createElement("div");
        wrapper.innerHTML = wishlistButton;
        const newWishListButton = wrapper.querySelector("cs-wishlist-button");
        this.wishlistButton.parentElement.replaceChild(newWishListButton, this.wishlistButton);
        this.wishlistButton = newWishListButton;
      }
    }
    updateMediaGallery(variantTitle, variantHandle, variantHandle2) {
      const defaultMediaIndexes = JSON.parse(this.mediaGallery.dataset.defaultMedia);
      console.log({
        defaultMediaIndexes
      });
      const isAirpodsPage = this.dataset.productType === "Airpods Pouch";
      if (!variantHandle && !variantHandle2) {
        if (defaultMediaIndexes !== null || isAirpodsPage) {
          const imagesToShow = 5;
          let flickitySlides = null;
          let flickityThumbs = null;
          if (this.mediaSlider) {
            const mediaSliderSorted = [...this.mediaSlider?.slides].sort((a, b) => parseInt(a.dataset.defaultPosition) - parseInt(b.dataset.defaultPosition));

            // console.log(mediaSliderSorted)
            let slidesToShow = [];
            let slidesToHide = [];
            if (isAirpodsPage && defaultMediaIndexes == null) {
              slidesToShow = mediaSliderSorted?.slice?.(0, imagesToShow) ?? [];
              slidesToHide = mediaSliderSorted?.slice?.(imagesToShow, this.mediaSlider?.slides.length) ?? [];
            } else {
              defaultMediaIndexes.forEach(i => {
                if (mediaSliderSorted[i - 1]) {
                  slidesToShow.push(mediaSliderSorted[i - 1]);
                }
              });
              mediaSliderSorted.forEach((item, index) => {
                if (!defaultMediaIndexes.includes(index + 1)) {
                  slidesToHide.push(item);
                }
              });
            }
            flickitySlides = themeVendor.Flickity.data(this.mediaSlider.el);
            flickitySlides?.remove(this.mediaSlider?.slides ?? []);
            slidesToShow.forEach((slide, idx) => {
              flickitySlides?.insert([slide], idx);
            });
            if (!flickitySlides) {
              this.mediaSlider.el.replaceChildren(...slidesToShow);
            }
            slidesToHide?.forEach((_, idx) => {
              this.mediaSlider.hidden.push(imagesToShow + idx);
            });
          } else {
            return;
          }
          if (this.mediaThumbs) {
            const mediaThumbsSorted = [...this.mediaThumbs?.thumbs].sort((a, b) => parseInt(a.dataset.defaultPosition) - parseInt(b.dataset.defaultPosition));
            let thumbsToShow = [];
            if (isAirpodsPage && defaultMediaIndexes == null) {
              thumbsToShow = mediaThumbsSorted?.slice?.(0, imagesToShow) ?? [];
            } else {
              defaultMediaIndexes.forEach(i => {
                if (mediaThumbsSorted[i - 1]) {
                  thumbsToShow.push(mediaThumbsSorted[i - 1]);
                }
              });
            }
            flickityThumbs = themeVendor.Flickity.data(this.mediaThumbs.el);
            flickityThumbs?.remove(this.mediaThumbs?.thumbs ?? []);
            thumbsToShow.forEach((thumb, idx) => {
              flickityThumbs?.insert([thumb], idx);
            });
            if (!flickityThumbs && this.mediaThumbs) {
              this.mediaThumbs.el.replaceChildren(...thumbsToShow);
            }
          }
          if (flickitySlides) {
            setTimeout(() => {
              flickitySlides.resize();
            }, 250);
          }
          if (flickityThumbs) {
            setTimeout(() => {
              flickityThumbs.resize();
            }, 250);
          }
        }
        return;
      }
      let flickitySlides = null;
      let flickityThumbs = null;

      /* Set media slider & thumbnails slider to default state - Start */
      if (this.mediaSlider) {
        flickitySlides = themeVendor.Flickity.data(this.mediaSlider.el);
        flickitySlides?.remove(this.mediaSlider?.slides ?? []);
        this.mediaSlider?.slides.forEach((slide, idx) => {
          flickitySlides?.insert([slide], idx);
        });
        if (!flickitySlides) {
          this.mediaSlider.el.replaceChildren(...this.mediaSlider.slides);
        }
        this.mediaSlider.hidden = [];
        if (flickitySlides) {
          setTimeout(() => {
            flickitySlides.resize();
          }, 250);
        }
        if (flickityThumbs) {
          setTimeout(() => {
            flickityThumbs.resize();
          }, 250);
        }
      } else {
        return;
      }
      if (this.mediaThumbs) {
        flickityThumbs = themeVendor.Flickity.data(this.mediaThumbs.el);
        flickityThumbs?.remove(this.mediaThumbs?.thumbs ?? []);
        this.mediaThumbs?.thumbs.forEach((thumb, idx) => {
          flickityThumbs?.insert([thumb], idx);
        });
        if (!flickityThumbs) {
          this.mediaThumbs.el.replaceChildren(...this.mediaThumbs.thumbs);
        }
      }
      /* Set media slider & thumbnails slider to default state - End */

      if (this.mediaSlider?.hidden.length) {
        this.mediaSlider.hidden.forEach(idx => {
          flickitySlides?.insert([this.mediaSlider.slides[idx]], idx);
          flickityThumbs?.insert([this.mediaThumbs?.thumbs[idx]], idx);
        });
        this.mediaSlider.hidden.length = 0;
      }
      const match = this.mediaSlider.slides.find(slide => slide.dataset.variantHandle === variantHandle || slide.dataset.variantHandle === variantHandle2 || slide.dataset.variantTitle === variantTitle);
      if (match) {
        const thumbsToRemove = [];
        const slidesToShow = [];
        const thumbsToShow = [];
        this.mediaSlider.slides.forEach((slide, idx) => {
          if (slide.dataset.variantHandle !== variantHandle && slide.dataset.variantHandle !== variantHandle2 && slide.dataset.variantTitle !== variantTitle) {
            thumbsToRemove.push(this.mediaThumbs?.thumbs[idx]);
            this.mediaSlider.hidden.push(idx);
          } else {
            if (slide.dataset.featuredMedia === "true") {
              slidesToShow.unshift(slide);
              thumbsToShow.unshift(this.mediaThumbs?.thumbs[idx]);
            } else {
              slidesToShow.push(slide);
              thumbsToShow.push(this.mediaThumbs?.thumbs[idx]);
            }
          }
        });
        flickitySlides?.remove(this.mediaSlider?.slides ?? []);
        slidesToShow.forEach((slide, idx) => {
          flickitySlides?.insert([slide], idx);
        });
        if (!flickitySlides) {
          this.mediaSlider.el.replaceChildren(...slidesToShow);
        }
        flickityThumbs?.remove(this.mediaThumbs?.thumbs ?? []);
        thumbsToShow.forEach((thumb, idx) => {
          flickityThumbs?.insert([thumb], idx);
        });
        if (!flickityThumbs && this.mediaThumbs) {
          this.mediaThumbs.el.replaceChildren(...thumbsToShow);
        }
      }
      if (flickitySlides) {
        setTimeout(() => {
          flickitySlides.resize();
        }, 250);
      }
      if (flickityThumbs) {
        setTimeout(() => {
          flickityThumbs.resize();
        }, 250);
      }
    }
  }
  customElements.define("atc-form", ATCForm);
  class ATCFormBundle extends ATCForm {
    constructor() {
      super(true);
      this.variantSelectors = Array.from(this.querySelectorAll("select")).map(selector => ({
        self: selector,
        options: Array.from(selector.querySelectorAll("option"))
      }));
      // Product options in squares
      this.variantSquareOptions = this.querySelectorAll("input[type=radio]");
      this.discount = Number(this.dataset.discount || "0");
      this.containerPrice = Number(this.dataset.containerPrice || "0");
      this.containerComparePrice = Number(this.dataset.containerComparePrice || "0");
      this.useContainerPrice = this.dataset.useContainerPrice === "true";
      // this.dynamicDiscount = !!this.dataset.dynamicDiscount;
      this.dynamicDiscount = this.dataset.dynamicDiscount === "true";
      this.init();
    }
    init() {
      if (this.variantSelectors.length) {
        this.variantSelectors.forEach((selector, index) => {
          const selectValueEl = selector.self.closest(".select-wrapper").querySelector("#SelectValue");
          const preSelectedOption = selector.options.find(option => option.value === selector.self.value);
          if (preSelectedOption && preSelectedOption.text.toLowerCase() !== "select size") {
            selectValueEl.innerHTML = preSelectedOption.text;
            selectValueEl.classList.add("selected");
          }
          selector.self.addEventListener("change", () => {
            const selectedOptions = this.variantSelectors.map(selector => {
              const value = selector.self.value;
              return value && selector.options?.find(option => option.value === value);
            });
            const selectedName = selector.self.options[selector.self.selectedIndex].text;
            selectValueEl.innerHTML = selectedName;
            if (!selectValueEl.classList.contains("selected")) {
              selectValueEl.classList.add("selected");
            }
            if (selectedOptions.some(option => !Boolean(option))) return;
            const soldOut = selectedOptions.some(option => option.dataset.soldOut === "true");
            this.updateAtcButton("bundle", soldOut, "Sold out", "");
            const totalPrice = selectedOptions.reduce((acc, option) => {
              return acc += Number(option.dataset.price);
            }, 0);
            let discountedPrice;
            if (this.dynamicDiscount) {
              if (this.containerPrice < totalPrice) {
                discountedPrice = this.containerPrice;
                this.querySelector('input[name="dsc"]').value = (totalPrice - discountedPrice) / totalPrice * 100;
              } else {
                this.querySelector('input[name="dsc"]').value = 0;
                discountedPrice = totalPrice;
              }
            } else {
              discountedPrice = totalPrice * ((100 - Number(this.discount)) / 100);
            }
            if (this.useContainerPrice && this.dynamicDiscount) {
              this.updatePriceWrappers("bundle", window.formatMoney(this.containerPrice), this.containerPrice < this.containerComparePrice ? window.formatMoney(this.containerComparePrice) : "", this.containerPrice < this.containerComparePrice ? window.formatMoney(this.containerComparePrice - this.containerPrice) : "");
            } else {
              this.updatePriceWrappers("bundle", window.formatMoney(discountedPrice), discountedPrice < totalPrice && !this.dynamicDiscount ? window.formatMoney(totalPrice) : "", discountedPrice < totalPrice && !this.dynamicDiscount ? window.formatMoney(totalPrice - discountedPrice) : "");
            }
            if (this.remainingStockWrapper) {
              const stock = Math.min(...selectedOptions.map(option => Number(option.dataset.stock)));
              this.updateRemainingStockWrapper(stock);
            }
          });
        });
      } else if (this.variantSquareOptions.length) {
        this.variantSquareOptions.forEach(option => {
          if (option.checked) {
            option.closest('.product-option-square').classList.add('selected');
          }
          if (option.disabled) {
            option.closest('.product-option-square').classList.add('disabled');
          }
          option.addEventListener("change", () => {
            let selectedOptions = [];
            this.variantSquareOptions.forEach(option => {
              option.closest('.product-option-square').classList.remove('selected');
              if (option.checked) {
                selectedOptions.push(option);
              }
            });
            option.closest('.product-option-square').classList.add('selected');
            if (selectedOptions.some(option => !Boolean(option))) return;
            const soldOut = selectedOptions.some(option => option.dataset.soldOut === "true");
            this.updateAtcButton("bundle", soldOut, "Sold out", "");
            const totalPrice = selectedOptions.reduce((acc, option) => {
              return acc += Number(option.dataset.price);
            }, 0);
            let discountedPrice;
            if (this.dynamicDiscount) {
              if (this.containerPrice < totalPrice) {
                discountedPrice = this.containerPrice;
                this.querySelector('input[name="dsc"]').value = (totalPrice - discountedPrice) / totalPrice * 100;
              } else {
                this.querySelector('input[name="dsc"]').value = 0;
                discountedPrice = totalPrice;
              }
            } else {
              discountedPrice = totalPrice * ((100 - Number(this.discount)) / 100);
            }
            if (this.useContainerPrice && this.dynamicDiscount) {
              this.updatePriceWrappers("bundle", window.formatMoney(this.containerPrice), this.containerPrice < this.containerComparePrice ? window.formatMoney(this.containerComparePrice) : "", this.containerPrice < this.containerComparePrice ? window.formatMoney(this.containerComparePrice - this.containerPrice) : "");
            } else {
              this.updatePriceWrappers("bundle", window.formatMoney(discountedPrice), discountedPrice < totalPrice && !this.dynamicDiscount ? window.formatMoney(totalPrice) : "", discountedPrice < totalPrice && !this.dynamicDiscount ? window.formatMoney(totalPrice - discountedPrice) : "");
            }
            if (this.remainingStockWrapper) {
              const stock = Math.min(...selectedOptions.map(option => Number(option.dataset.stock)));
              this.updateRemainingStockWrapper(stock);
            }
          });
        });
      }
    }
  }
  customElements.define("atc-form-bundle", ATCFormBundle);
  class CountrySelectorPopup extends HTMLElement {
    constructor() {
      super();
      this.triggers = document.querySelectorAll("[data-country-selector-trigger]");
      this.wrapper = this.querySelector("[data-popup-wrapper]");
      this.closeButton = this.querySelector("[data-close-button]");
      this.cancelButton = this.querySelector("[data-cancel-button]");
      this.triggers.forEach(trigger => {
        trigger.addEventListener("click", () => {
          this.wrapper.setAttribute("data-active", true);
          document.documentElement.style.overflowY = "hidden";
        });
      });
      this.wrapper.addEventListener("click", e => {
        e.stopPropagation();
        if (e.target === e.currentTarget || this.closeButton.contains(e.target) || this.cancelButton.contains(e.target)) {
          this.wrapper.removeAttribute("data-active");
          document.documentElement.style.overflowY = "unset";
        }
      });
    }
  }
  customElements.define("country-selector-popup", CountrySelectorPopup);
  class BackInStock extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector("form");
      this.emailInput = this.form.querySelector('[name="email"]');
      this.productIdInput = this.form.querySelector('[name="product_id"]');
      this.variantIdInput = this.form.querySelector('[name="variant_id"]');
      this.marketingCheckbox = this.form.querySelector('[name="accepts_marketing"]');
      this.submitBtn = this.form.querySelector('button[type="submit"]');
      this.closeBtns = this.querySelectorAll(".js-close-btn");
      this.errorBox = this.querySelector(".js-error");
      this.form.addEventListener("submit", e => {
        e.preventDefault();
        e.stopPropagation();
        if (!this.emailInput.value || !this.productIdInput.value || !this.variantIdInput.value) {
          return;
        }
        this.submitBtn.setAttribute("disabled", "disabled");

        // BIS.create(
        //   this.emailInput.value,
        //   this.variantIdInput.value,
        //   this.productIdInput.value,
        //   { accepts_marketing: !!this.marketingCheckbox.checked }
        // ).then((res) => {
        //   if (res.status === "OK") {
        //     this.setAttribute("data-submitted", true);
        //   } else {
        //     this.errorBox.innerText =
        //       res.errors?.base || res.errors?.email || "Something went wrong.";
        //     this.submitBtn.removeAttribute("disabled");
        //   }
        // });

        let klaviyoKey = "eH8uTZ";
        let email = this.emailInput.value;
        let productId = this.productIdInput.value;
        let variantId = this.variantIdInput.value;
        if (!variantId) {
          variantId = productId;
        }
        const options = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            revision: "2024-06-15"
          },
          body: JSON.stringify({
            data: {
              type: "back-in-stock-subscription",
              attributes: {
                channels: ["EMAIL"],
                profile: {
                  data: {
                    type: "profile",
                    attributes: {
                      email: email
                    }
                  }
                }
              },
              relationships: {
                variant: {
                  data: {
                    type: "catalog-variant",
                    id: `$shopify:::$default:::${variantId}`
                  }
                }
              }
            }
          })
        };
        fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${klaviyoKey}`, options).then(response => {
          // console.log(response)
          if (!response.ok) {
            throw new Error(`An error occurred: ${response.status}`);
          }
          return response.text();
        }).then(res => {
          // console.log(res);
          this.setAttribute("data-submitted", true);
        }).catch(error => {
          // console.log(error)
          this.errorBox.innerText = error.message || "Something went wrong.";
          this.submitBtn.removeAttribute("disabled");
        });
      });
      this.closeBtns.forEach(btn => {
        btn.addEventListener("click", () => {
          document.querySelector("body").style.overflow = "unset";
          document.documentElement.style.overflow = "unset";
          this.removeAttribute("data-active");
          this.removeAttribute("data-submitted");
          this.submitBtn.removeAttribute("disabled");
          this.emailInput.value = "";
          this.marketingCheckbox.checked = true;
          this.errorBox.innerHTML = "";
        });
      });
      this.activate = this.activate.bind(this);
    }
    activate() {
      document.querySelector("body").style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
      this.setAttribute("data-active", true);
    }
  }
  customElements.define("back-in-stock", BackInStock);
  class ProductSwatches extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelectorAll("[data-product-swatch]");
      this.activeSwatch = this.querySelector('[data-product-swatch][data-active="true"]');
      this.productCard = this.closest(".product-grid-item");
      this.label = this.productCard?.querySelector("[data-color-label]");
      this.productBadge = this.productCard?.querySelector("[data-product-badge]");
      this.productTitle = this.productCard?.querySelector(".product-grid-item__title");
      this.productPrice = this.productCard?.querySelector(".product-grid-item__price");
      this.featuredImage = this.productCard?.querySelector("[data-product-image] img");
      this.hoverImage = this.productCard?.querySelector("[data-product-image-hover] img");
      this.productLinks = this.productCard?.querySelectorAll("[data-grid-link]");
      this.wishlistButton = this.productCard?.querySelector("cs-wishlist-button");
      this.productRating = this.productCard?.querySelector(".yotpo.bottomLine");
      this.allShown = false;
      this.viewAllButton = this.querySelector("[data-view-all-button]");
      this.initHoverHandlers = this.initHoverHandlers.bind(this);
      this.initViewAllButton = this.initViewAllButton.bind(this);
      this.handleVariantChange = this.handleVariantChange.bind(this);
      this.initViewAllButton();
      if (this.productCard) {
        this.initHoverHandlers();
      }
    }
    initHoverHandlers() {
      this.swatches.forEach(swatch => {
        const dataset = swatch.dataset;
        var productBadgeTempParent = document.createElement("div");
        productBadgeTempParent.innerHTML = swatch.dataset.productBadge.trim();
        const productBadge = productBadgeTempParent.firstChild;
        const productId = dataset.productId;
        const productTitle = dataset.productTitle;
        const swatchLabel = dataset.swatchLabel;
        const featuredImage = dataset.featuredImage;
        const hoverImage = dataset.hoverImage;
        const productPrice = dataset.productPrice;
        const wishlistButton = dataset.wishlistButton;
        const productRating = this.querySelector(`#product-rating-${productId} .yotpo.bottomLine`);
        const url = swatch.href;
        swatch.addEventListener("click", e => {
          e.preventDefault();
          this.activeSwatch.removeAttribute("data-active");
          this.activeSwatch = swatch;
          swatch.setAttribute("data-active", true);
          this.productLinks?.forEach(link => {
            link.href = url;
          });
          if (this.label) {
            this.label.innerText = swatchLabel;
          }
          if (this.productBadge && productBadge) this.productBadge.innerHTML = productBadge.innerHTML;
          if (this.productTitle && productTitle) this.productTitle.innerText = productTitle;
          if (this.productPrice && productPrice) this.productPrice.innerHTML = productPrice;
          if (this.featuredImage && featuredImage) {
            this.featuredImage.removeAttribute("srcset");
            this.featuredImage.removeAttribute("sizes");
            this.featuredImage.setAttribute("src", featuredImage);
          }
          if (this.hoverImage && hoverImage) {
            this.hoverImage.removeAttribute("srcset");
            this.hoverImage.removeAttribute("sizes");
            this.hoverImage.setAttribute("src", hoverImage);
          }
          if (this.wishlistButton && wishlistButton) {
            // const unique_id = `sws-${Date.now()}`;
            // this.productCard.setAttribute("data-swymn-selector", unique_id);
            const wrapper = document.createElement("div");
            wrapper.innerHTML = wishlistButton;
            const newWishListButton = wrapper.querySelector("cs-wishlist-button");
            this.wishlistButton.parentElement.replaceChild(newWishListButton, this.wishlistButton);
            this.wishlistButton = newWishListButton;
          }
          console.log(this.productRating);
          console.log(productRating);
          if (this.productRating && productRating) {
            this.productRating?.parentElement?.replaceChild(productRating, this.productRating);
            this.productRating = productRating;
          }
        });
      });
    }
    initViewAllButton() {
      if (!this.viewAllButton) return;
      this.viewAllButton?.addEventListener("click", () => {
        this.allShown = true;
        this.viewAllButton.removeAttribute("data-active");
        this.swatches.forEach(swatch => {
          swatch.classList.remove("--hidden");
        });
      });
    }
    handleVariantChange(variant_handle) {
      let availableCount = 0;
      this.swatches.forEach(swatch => {
        const handlesAndIds = swatch.getAttribute("data-available-variant-handles-and-ids")?.split(",");
        const matchingVariantId = handlesAndIds.find(handle => handle?.split(":")?.[0] === variant_handle)?.split(":")?.[1];
        if (variant_handle && !matchingVariantId) {
          swatch.classList.add("--unavailable");
        } else {
          swatch.classList.remove("--unavailable");
          swatch.setAttribute("href", `${swatch.href.split("?variant")[0]}${matchingVariantId ? "?variant=" + matchingVariantId : ""}`);
          availableCount++;
        }
        swatch.classList.toggle("--hidden", !this.allShown && (this.productCard && availableCount > 4 || availableCount > 8));
      });
      if (this.viewAllButton) {
        this.viewAllButton.toggleAttribute("data-active", !this.allShown && (this.productCard && availableCount > 4 || availableCount > 8));
      }
    }
  }
  customElements.define("product-swatches", ProductSwatches);
  class ShoppableVideos extends HTMLElement {
    constructor() {
      super();
      this.imagesToReplace = Array.from(this.querySelectorAll("img[data-video-replacement]")).map(img => {
        const replacement = img.dataset.videoReplacement;
        if (replacement) {
          return {
            el: img,
            replacement
          };
        }
      }).filter(Boolean);
      this.popupTriggers = this.querySelectorAll("[data-shoppable-video-trigger]");
      this.popups = Array.from(this.querySelectorAll("[data-shoppable-video-popup]"));
      this.popupsWrapper = this.querySelector("[data-popups]");
      this.activeVideo = null;
      this.watchTopDistances = this.watchTopDistances.bind(this);
      this.addEventListeners = this.addEventListeners.bind(this);
      this.removeEventListeners = this.removeEventListeners.bind(this);
      this.initializePopups = this.initializePopups.bind(this);
    }
    connectedCallback() {
      if (this.imagesToReplace.length) {
        this.watchTopDistances();
        this.addEventListeners();
      }
      this.initializePopups();
    }
    disconnectedCallback() {
      this.removeEventListeners();
    }
    addEventListeners() {
      window.addEventListener("scroll", this.watchTopDistances);
      window.addEventListener("resize", this.watchTopDistances);
    }
    removeEventListeners() {
      window.removeEventListener("scroll", this.watchTopDistances);
      window.removeEventListener("resize", this.watchTopDistances);
    }
    watchTopDistances() {
      let remaining = [];
      this.imagesToReplace.forEach(img => {
        const topDist = img.el.getBoundingClientRect().top;
        if (topDist < window.innerHeight + 100) {
          const wrapper = document.createElement("div");
          wrapper.innerHTML = img.replacement;
          const video = wrapper.querySelector("video");
          const maxDuration = Number(video.dataset.maxDuration);
          img.el.parentElement.replaceChild(video, img.el);
          if (!isNaN(maxDuration) && maxDuration > 0) {
            video.addEventListener("timeupdate", () => {
              if (video.currentTime > maxDuration) {
                video.currentTime = 0;
              }
            });
          }
          const videoWrapperWithCanvas = video.closest("[data-video-wrapper-with-canvas]");
          if (videoWrapperWithCanvas) {
            let v = video;
            let canvas = videoWrapperWithCanvas.querySelector("canvas");
            let context = canvas.getContext("2d");
            let draw = () => {
              var cw = canvas.clientWidth;
              var ch = canvas.clientHeight;
              canvas.width = cw;
              canvas.height = ch;
              if (v.paused || v.ended) return false;
              context.drawImage(v, 0, 0, cw, ch);
            };
            let loop;
            if ("requestVideoFrameCallback" in HTMLVideoElement.prototype) {
              loop = () => {
                v.requestVideoFrameCallback(() => {
                  draw();
                  loop();
                });
              };
            } else {
              loop = () => {
                requestAnimationFrame(() => {
                  draw();
                  loop();
                });
              };
            }
            loop();
          }
        } else {
          remaining.push(img);
        }
      });
      this.imagesToReplace = remaining;
      if (!this.imagesToReplace.length) {
        this.removeEventListeners();
      }
    }
    initializePopups() {
      this.popupTriggers.forEach(trigger => {
        trigger.addEventListener("click", () => {
          const popup = this.popups.find(popup => popup.dataset.blockId === trigger.dataset.blockId);
          if (popup) {
            popup.setAttribute("data-active", "true");
            this.popupsWrapper.setAttribute("data-active", "true");
            popup.querySelector("video")?.play();
          }
        });
      });
      this.popups.forEach((popup, idx) => {
        const video = popup.querySelector("video");
        const productTriggers = popup.querySelectorAll("[data-product-trigger]");
        const productContainers = Array.from(popup.querySelectorAll("[data-product]"));
        video.addEventListener("load", () => {
          video.poster = null;
        });
        const productsContainer = popup.querySelector("[data-products-container]");
        const productsContainerClose = popup.querySelector("[data-products-container-close-button]");
        const mobileProductLinks = popup.querySelectorAll("[data-mobile-product-link]");
        const mobileViewAllProducts = popup.querySelector("[data-mobile-view-all-products]");
        const closeButton = popup.querySelector("[data-close-button]");
        const soundToggle = popup.querySelector("[data-sound-toggle]");
        const navButtons = popup.querySelectorAll("[data-nav-button]");
        closeButton.addEventListener("click", () => {
          video.pause();
          video.currentTime = 0.001;
          this.popupsWrapper.removeAttribute("data-active");
          popup.removeAttribute("data-active");
        });
        soundToggle.addEventListener("click", () => {
          if (soundToggle.dataset.muted) {
            soundToggle.removeAttribute("data-muted");
          } else {
            soundToggle.setAttribute("data-muted", "true");
          }
          video.muted = !video.muted;
        });
        navButtons.forEach(button => {
          button.addEventListener("click", () => {
            let targetPopup = null;
            if (button.dataset.type === "next") {
              targetPopup = this.popups[idx === this.popups.length - 1 ? 0 : idx + 1];
            } else {
              targetPopup = this.popups[idx === 0 ? this.popups.length - 1 : idx - 1];
            }
            video.pause();
            video.currentTime = 0.001;
            targetPopup.setAttribute("data-active", "true");
            targetPopup.querySelector("video")?.play();
            popup.removeAttribute("data-active");
          });
        });
        productTriggers.forEach(trigger => {
          const viewButton = trigger.querySelector("[data-view-button]");
          viewButton.addEventListener("click", () => {
            let productContainer = productContainers.find(container => container.dataset.productId === trigger.dataset.productId);
            if (productContainer) {
              productContainer.setAttribute("data-active", true);
              if (window.innerWidth <= 767) {
                productsContainer.style.height = `${productContainer.offsetHeight}px`;
              }
            }
          });
        });
        productContainers.forEach(container => {
          const backButton = container.querySelector("[data-back-button]");
          backButton.addEventListener("click", () => {
            container.removeAttribute("data-active", true);
            productsContainer.removeAttribute("style");
          });
        });
        productsContainerClose.addEventListener("click", () => {
          productsContainer.removeAttribute("data-active");
        });
        mobileProductLinks.forEach(link => {
          link.addEventListener("click", () => {
            const product = productContainers.find(container => container.dataset.productId === link.dataset.productId);
            if (product) {
              product.classList.add("--no-transition");
              product.setAttribute("data-active", true);
              productsContainer.setAttribute("data-active", true);
              productsContainer.style.height = `${product.offsetHeight}px`;
              setTimeout(() => {
                product.classList.remove("--no-transition");
              }, 0);
            }
          });
        });
        mobileViewAllProducts.addEventListener("click", () => {
          productsContainer.setAttribute("data-active", true);
        });
      });
    }
  }
  customElements.define("shoppable-videos", ShoppableVideos);

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

// Hide extra custom links on the PDP
(() => {
  const links = document.querySelectorAll(".js-custom-link");
  links.forEach(link => {
    link.style.display = "none";
  });
  const sizeLinksArray = Array.from(links).filter(link => link.closest(".custom-atc-form"));
  if (!sizeLinksArray.length) return;
  sizeLinksArray[0].style.display = "block";
})();

// Hide size guide button on the PDP when there is no size selector
(() => {
  const popupBlock = document.querySelector(".js-popup-for-size");
  if (!popupBlock) return;
  const sizeSelector = document.querySelectorAll(".radio__fieldset:not(.--hidden)");
  if (sizeSelector.length) {
    const iphoneOption = Array.from(sizeSelector[0].querySelectorAll("option")).find(option => option.innerText.toLowerCase().includes("iphone"));
    if (iphoneOption) {
      popupBlock.style.display = "block";
    } else {
      popupBlock.style.display = "none";
    }
  } else {
    popupBlock.style.display = "none";
  }
})();

// Create a wrapper and put all size guide popup images

(() => {
  const popupBlock = document.querySelector(".js-size-popup");
  if (!popupBlock) return;
  const sizeGuideImages = popupBlock.querySelectorAll("img");
  const wrapper = document.createElement("div");
  wrapper.classList.add("size-guide-images-wrapper");
  sizeGuideImages.forEach(image => {
    wrapper.appendChild(image.parentElement);
  });
  popupBlock.querySelector(".product__popup__content").appendChild(wrapper);
})();
